// Mini-game dealing: counts for the setup screen, then cards a batch at a time.
import type { Category, DealBatch, Difficulty, MinigameName, MinigameStats } from '@shared/minigames';

async function request<T>(path: string, init?: RequestInit & { json?: unknown }): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`/api/minigames${path}`, {
      ...init,
      headers: init?.json !== undefined ? { 'content-type': 'application/json' } : undefined,
      body: init?.json !== undefined ? JSON.stringify(init.json) : undefined,
    });
  } catch {
    throw new Error('Could not reach the server. Check your connection.');
  }
  const body = (await res.json().catch(() => null)) as (T & { error?: string }) | null;
  if (!res.ok || !body) throw new Error(body?.error ?? `Request failed (${res.status}).`);
  return body;
}

export const minigameApi = {
  stats: (game: MinigameName) => request<MinigameStats>(`/${game}/stats`),
  deal: (game: MinigameName, filters: { difficulties?: Difficulty[]; categories?: Category[] }) =>
    request<DealBatch>(`/${game}/deal`, { method: 'POST', json: filters }),
  more: (sessionId: string) => request<DealBatch>(`/deal/${encodeURIComponent(sessionId)}/more`, { method: 'POST', json: {} }),
};
